import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase';

export async function updateSingleElementPrompt(bookId, spreadId, elementId) {
  try {
    const updateSingleElementPromptFn = httpsCallable(functions, 'updateSingleElementPrompt');
    const result = await updateSingleElementPromptFn({
      bookId,
      spreadId,
      elementId
    });
    return result.data;
  } catch (error) {
    console.error('Error updating single element prompt:', error);
    throw error;
  }
}
